import { useState } from "react";

// Which rows of a list have a download running, so each row's button can spin
// until its own file arrives. Tracked per key rather than as one "current"
// row: a customer can start a second row before the first finishes, and one
// shared slot would stop the first spinner early and re-enable the second
// while it is still downloading.
export function useDownloadsInFlight(): {
  isDownloading: (key: string) => boolean;
  download: (key: string, run: () => Promise<void>) => Promise<void>;
} {
  const [keys, setKeys] = useState<ReadonlySet<string>>(new Set());

  async function download(key: string, run: () => Promise<void>) {
    setKeys((previous) => new Set(previous).add(key));
    try {
      await run();
    } finally {
      setKeys((previous) => {
        const next = new Set(previous);
        next.delete(key);
        return next;
      });
    }
  }

  return { isDownloading: (key) => keys.has(key), download };
}
